<template>
  <div class="home-wrapper">
    <div class="home-area home-item">
      <div class="area-name">
        <div
          class="area-text"
          v-for="item in $store.state.public.provinceList"
          :key="item.id"
          :class="{ active: item.id === curProvinceId }"
          @click="onAreaClick(item)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>

    <div class="home-item news">
      <Card
        dis-hover
        :bordered="false"
        :padding="0"
        style="
          width: 800px;
          height: 256px;
          overflow: hidden;
          border-radius: 8px;
        "
      >
        <div class="news-head">
          <HomeTitle :icon="titleIcon1">招考信息</HomeTitle>
          <!-- <div class="more-news">更多</div> -->
        </div>
        <div class="news-content">
          <div
            class="news-list"
            v-for="(item, i) in hotArticle"
            :key="i"
            @click="goArticle(item.id)"
          >
            <div class="news-tag">
              <MyTag
                color="#00737C"
                size="12px"
                padding="2px 5px"
                backgroundColor="rgba(0, 115, 124, 0.07)"
                >{{ item.cate_name }}</MyTag
              >
              <!-- <MyTag color="#FF5422" backgroundColor="rgba(255, 84, 34, 0.1)"
                >即将截止</MyTag
              > -->
            </div>
            <div class="news-items">
              <span :title="item.title">{{ item.title }}</span>
            </div>
          </div>
        </div>
      </Card>
      <div class="active-info">
        <Carousel v-model="curCarouselItem" autoplay dots loop>
          <CarouselItem @click="showPoster">
            <div class="demo-carousel">
              <img src="../assets/images/home-active-image.png" />
            </div>
          </CarouselItem>
        </Carousel>
      </div>
    </div>

    <div class="home-item" v-if="auditionCourseList.length > 0">
      <HomeTitle :icon="titleIcon2">试听课程</HomeTitle>

      <div class="audition-content">
        <template v-for="(item, key) in auditionCourseList">
          <MyCard
            :image="imgurl + item.banner"
            :imageHeight="164"
            :key="key"
            class="course-item"
            @click="goVideo(item)"
            v-if="key < 4"
          >
            <div class="course-info">
              <div class="course-name" :title="item.title">
                {{ item.title }}
              </div>
              <div class="course-desc">
                <div class="course-price">
                  <span class="course-unit">￥</span>{{ item.price }}
                  <!-- <span class="course-unit"
                  >.{{ item.price}}</span
                > -->
                </div>
                <!-- <div class="course-ori-price">￥{{ item.originPrice }}</div> -->
                <div class="course-learn-count">
                  {{ item.learnCount }}人已学
                </div>
              </div>
            </div>
          </MyCard>
        </template>
      </div>
    </div>

    <div class="home-item home-test">
      <HomeTitle :icon="titleIcon3">测试题</HomeTitle>

      <div class="home-test-content">
        <div class="home-test-head">
          <div class="home-test-title">
            化零为整，厘清问题类材料中的乱序逻辑
          </div>
          <div class="home-test-subtitle">知识点，海量的备考资料</div>
        </div>
        <div class="home-test-foot">
          <div class="home-test-card">
            <div class="home-test-card-title">题库</div>
            <div class="home-test-card-subtitle">历年试卷</div>

            <div class="home-test-card-list">
              <div class="home-test-card-list-item">
                <div class="home-icon">
                  <Icon color="#03BF9A" size="11" type="md-checkmark" />
                </div>
                <div class="home-test-card-list-item-main">实时更新</div>
                <div class="home-test-card-list-item-sub"></div>
              </div>
              <div class="home-test-card-list-item">
                <div class="home-icon">
                  <Icon color="#03BF9A" size="11" type="md-checkmark" />
                </div>
                <div class="home-test-card-list-item-main">把握趋势</div>
                <div class="home-test-card-list-item-sub"></div>
              </div>
              <div class="home-test-card-list-item">
                <div class="home-icon">
                  <Icon color="#03BF9A" size="11" type="md-checkmark" />
                </div>
                <div class="home-test-card-list-item-main">知识点全面涵盖</div>
                <div class="home-test-card-list-item-sub"></div>
              </div>
            </div>

            <my-button
              class="home-test-card-button"
              width="446px"
              height="50px"
              :radius="8"
              linear-gradient="linear-gradient(to right,#02BD98,#05E0C9)"
              color="#ffffff"
              weight="600"
              :size="20"
              spacing="20px"
              style="margin-top: 26px"
              @click="toPractic"
              >去练习</my-button
            >
          </div>
          <div class="home-test-card">
            <div class="home-test-card-title">练习</div>
            <div class="home-test-card-subtitle">智能出题详细解析</div>

            <div class="home-test-card-list">
              <div class="home-test-card-list-item">
                <div class="home-icon">
                  <Icon color="#03BF9A" size="11" type="md-checkmark" />
                </div>
                <div class="home-test-card-list-item-main">科目分类</div>
                <div class="home-test-card-list-item-sub">专项练习</div>
              </div>
              <div class="home-test-card-list-item">
                <div class="home-icon">
                  <Icon color="#03BF9A" size="11" type="md-checkmark" />
                </div>
                <div class="home-test-card-list-item-main">知识点分类</div>
                <div class="home-test-card-list-item-sub">重点刷题</div>
              </div>
              <div class="home-test-card-list-item">
                <div class="home-icon">
                  <Icon color="#03BF9A" size="11" type="md-checkmark" />
                </div>
                <div class="home-test-card-list-item-main">智能分析</div>
                <div class="home-test-card-list-item-sub">收藏题目 错题本</div>
              </div>
            </div>

            <my-button
              class="home-test-card-button"
              width="446px"
              height="50px"
              :radius="8"
              linear-gradient="linear-gradient(to right,#02BD98,#05E0C9)"
              color="#ffffff"
              weight="600"
              :size="20"
              spacing="20px"
              @click="toPractic"
              >去测试</my-button
            >
          </div>
        </div>
      </div>
    </div>

    <div class="home-item">
      <HomeTitle :icon="titleIcon4">师资介绍</HomeTitle>

      <div class="techer-content">
        <MyCard
          v-for="(item, key) in teacherList"
          :image="imgurl + item.photopath"
          :key="key"
          :imageHeight="238"
          class="teacher-item"
          @click="goTeacherDetail(item.id)"
        >
          <div class="teacher-info">
            <div class="teacher-name">{{ item.title }}</div>
            <div class="teacher-rule">{{ item.info }}</div>
          </div>
        </MyCard>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HomeTitle from "@/components/title/home-title.vue";
import MyCard from "@/components/teacher/teacher-card.vue";
import MyButton from "@/components/my-button/my-button.vue";
import MyTag from "@/components/my-tag/my-tag.vue";

import HomeTitleIcon1 from "@/assets/images/home-title-icon1.png";
import HomeTitleIcon2 from "@/assets/images/home-title-icon2.png";
import HomeTitleIcon3 from "@/assets/images/home-title-icon3.png";
import HomeTitleIcon4 from "@/assets/images/home-title-icon4.png";

import { indexHot } from "@/api/article";
import { fetchFreeVideoList } from "@/api/course";
import { fetchTeacherList } from "@/api/teacher";

import { mapState } from "vuex";

export default {
  name: "HomeView",
  components: {
    HomeTitle,
    MyCard,
    MyTag,
    MyButton,
  },
  data() {
    return {
      titleIcon1: HomeTitleIcon1,
      titleIcon2: HomeTitleIcon2,
      titleIcon3: HomeTitleIcon3,
      titleIcon4: HomeTitleIcon4,
      newsList: [],
      auditionCourseList: [],
      curCarouselItem: 0,
      teacherList: [
        {
          image: "https://file.iviewui.com/images/image-demo-13.jpg",
          teacherName: "李梦圆",
          teacherDesc: "公考申论、面试主讲",
        },
        {
          image: "https://file.iviewui.com/images/image-demo-13.jpg",
          teacherName: "李梦圆",
          teacherDesc: "公考申论、面试主讲",
        },
        {
          image: "https://file.iviewui.com/images/image-demo-13.jpg",
          teacherName: "李梦圆",
          teacherDesc: "公考申论、面试主讲",
        },
        {
          image: "https://file.iviewui.com/images/image-demo-13.jpg",
          teacherName: "李梦圆",
          teacherDesc: "公考申论、面试主讲",
        },
        {
          image: "https://file.iviewui.com/images/image-demo-13.jpg",
          teacherName: "李梦圆",
          teacherDesc: "公考申论、面试主讲",
        },
      ],
      hotArticle: [], //招考信息
      imgurl: this.$host,
    };
  },

  computed: {
    ...mapState({
      curProvinceId: (state) => state.public.curProvinceId, // 假设Vuex中有一个名为count的状态
    }),
  },

  watch: {
    curProvinceId() {
      // 这里可以执行需要的操作
      this.getArticleHot(1, 10);
      this.getfetchFreeVideoList();
    },
  },

  mounted() {
    this.getArticleHot(1, 10); //招考信息分类ID
    this.getfetchFreeVideoList();
    this.getFetchTeacherList();
  },

  methods: {
    showPoster() {
      this.$store.commit("public/SET_POSTER_VISIABLE", true);
    },
    toPractic() {
      this.$router.push({
        path: "question-repository",
      });
    },
    getFetchTeacherList() {
      fetchTeacherList({}).then((res) => {
        if (res.code === 1) {
          this.teacherList = res.data.teacher;
        }
      });
    },

    //获取最新OR热点文章，热点暂未上线
    getArticleHot(cid, num) {
      indexHot({
        size: num,
        pid: this.curProvinceId,
      }).then((res) => {
        if (res.code === 1) {
          this.hotArticle = res.data.article;
        }
      });
    },

    goVideo(info) {
      if (this.$store.state.user.token) {
        window.localStorage.setItem("cache_course_vid", info.vid);
        this.$router.push({
          path: "course-video-list/" + info.cid,
        });
      } else {
        this.$store.commit("public/SET_LOGIN", true);
      }
    },

    goArticle(id) {
      const resolved = this.$router.resolve({
        path: "article-detail/" + id,
      });
      const newWindow = window.open(resolved.href, "_blank");
      newWindow.opener = null; // 防止新窗口保留对原窗口的引用
    },

    goTeacherDetail(id) {
      const resolved = this.$router.resolve({
        path: "teacher-detail/" + id,
      });
      const newWindow = window.open(resolved.href, "_blank");
      newWindow.opener = null; // 防止新窗口保留对原窗口的引用
    },

    getfetchFreeVideoList() {
      //auditionCourseList
      fetchFreeVideoList({ pid: this.curProvinceId }).then((res) => {
        if (res.code === 1) {
          this.auditionCourseList = res.data.video;
        }
      });
    },

    onAreaClick(area) {
      this.$store.commit("public/SET_PROVINCE", area.id);
    },
  },
};
</script>

<style lang="less" scoped>
.home-wrapper {
  width: 1220px;
  margin: 24px auto 0;

  .home-item {
    margin-bottom: 40px;
  }

  .news {
    display: flex;
    justify-content: space-between;
    .active-info {
      width: 380px;
      height: 256px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .news-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .more-news {
        color: #00737c;
        font-size: 12px;
        margin-right: 16px;
        cursor: pointer;
      }
    }

    .news-content {
      padding: 16px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .news-list {
        width: calc(50% - 20px); /* 设置子元素宽度为三分之一，减去一些间距 */
        margin: 0px 5px; /* 设置子元素之间的间距 */
        display: flex;
        align-items: center;
        height: 32px;
        margin: 3px 0;
        .news-tag {
          display: flex;
          align-items: center;
          flex: 1;
        }
        .news-items {
          width: calc(100% - 68px);
          display: flex;
          align-items: center;
          overflow: hidden;
          color: #727792;
          cursor: pointer;
          font-size: 16px;
          &:hover {
            color: #00737c;
          }
          span {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-weight: 300;
            color: #000000;
          }
        }
      }
    }
  }

  .home-area {
    width: 1220px;
    height: 90px;
    display: flex;
    align-items: center;
    padding: 20px 10px 20px 30px;
    background: url(@/assets/images/home-area.png);
    background-size: 100% 100%;

    .area-name {
      width: 1140px;
      height: 60px;
      align-content: space-around;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-left: 220px;
      flex-wrap: wrap;
      .area-text {
        flex-shrink: 0;
        margin: 0 2px;
        height: 24px;
        width: 56px;
        padding: 2px 0;
        display: -webkit-box;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: center;
        justify-content: center;
        cursor: pointer;
        font-size: 14px;
        color: #000000;
        border-radius: 2px;
        &.active {
          color: #00737c;
          font-weight: bold;
        }
      }
    }
  }

  .audition-content {
    display: flex;
    flex-wrap: wrap;
    margin-top: 30px;

    .course-item {
      width: 24%;
      margin-right: 1%;
      &:nth-child(4n + 4) {
        margin-right: 0;
      }

      .course-info {
        padding: 6px 16px 18px;
        .course-name {
          height: 22px;
          font-size: 16px;
          color: #3d3d3d;
          line-height: 22px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .course-desc {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          margin-top: 18px;
          .course-price {
            width: 47px;
            font-size: 20px;
            font-weight: bold;
            color: #b60909;
            line-height: 10px;
            .course-unit {
              font-size: 11px;
            }
          }

          .course-ori-price {
            height: 16px;
            font-size: 16px;
            font-weight: bold;
            color: #c6c5c5;
            line-height: 19px;
            text-decoration: line-through;
          }

          .course-learn-count {
            height: 17px;
            font-size: 12px;
            font-weight: 400;
            color: #c6c5c5;
            line-height: 20px;
          }
        }
      }
    }
  }

  .home-test {
    .home-test-content {
      width: 1220px;
      background: url(@/assets/images/home-test-bg.png) no-repeat;
      background-size: 100% 100%;
      margin-top: 30px;
      padding: 36px;

      .home-test-head {
        text-align: center;
        .home-test-title {
          height: 28px;
          font-size: 20px;
          font-weight: 600;
          color: #000000;
          line-height: 28px;
        }

        .home-test-subtitle {
          height: 20px;
          font-size: 16px;
          font-weight: 400;
          color: #000000;
          line-height: 20px;
          margin-top: 18px;
        }
      }

      .home-test-foot {
        display: flex;
        justify-content: space-around;
        margin-top: 48px;
        .home-test-card {
          width: 624px;
          padding: 30px;
          // background-color: #ffffff;
          background: url(@/assets/images/home-card-bg1.png) no-repeat;
          background-size: 100% 100%;

          &:last-child {
            background: url(@/assets/images/home-card-bg2.png) no-repeat;
          }

          .home-test-card-button {
            margin: 26px auto 0;
          }
          .home-test-card-title {
            height: 33px;
            font-size: 24px;
            font-weight: 600;
            color: #000000;
            line-height: 33px;
          }
          .home-test-card-subtitle {
            height: 20px;
            font-size: 16px;
            font-weight: 400;
            color: #000000;
            line-height: 20px;
            margin-top: 13px;
          }

          .home-test-card-list {
            margin-top: 36px;

            .home-test-card-list-item {
              display: flex;
              align-items: center;
              .home-test-card-list-item-main {
                height: 30px;
                font-size: 16px;
                font-weight: 400;
                color: #727792;
                line-height: 30px;
                margin-left: 5px;
              }

              .home-test-card-list-item-sub {
                height: 30px;
                font-size: 14px;
                font-weight: 400;
                color: #727792;
                line-height: 30px;
                margin-left: 10px;
              }
            }
          }
        }
      }
    }
  }

  .home-icon {
    width: 11px;
    height: 11px;
    background: #ecfafc;
    display: flex;
    justify-content: center;
    align-content: center;
  }

  .techer-content {
    display: flex;
    flex-wrap: wrap;
    margin-top: 30px;
    .teacher-item {
      width: 19.2%;
      margin-right: 1%;
      &:nth-child(5n + 5) {
        margin-right: 0;
      }
      .teacher-info {
        padding: 16px;

        .teacher-name {
          height: 20px;
          font-size: 20px;
          font-weight: 600;
          color: #3d3d3d;
          line-height: 20px;
        }

        .teacher-rule {
          height: 17px;
          font-size: 16px;
          font-weight: 400;
          color: #c6c5c5;
          line-height: 17px;
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
